import { render, staticRenderFns } from "./shareFileEditPopup.vue?vue&type=template&id=b0aa56ea"
import script from "./shareFileEditPopup.vue?vue&type=script&lang=js"
export * from "./shareFileEditPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports